import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { INGREDIENT_KEYWORDS_QUERY } from '../graphql/queries'
import { COMMON_FETCH_INGREDIENT_KEYWORDS } from '../redux/action-types'
import { cleanupCommonFetchIngredientKeywords } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useIngredientKeywordsQuery = (ingredientId, lazy) => {
  const dispatch = useDispatch()

  const { isLoading, error, data } = useSelector(
    store => store.common.ingredientKeywords || {},
  )

  const refetch = useCallback(
    ingredientId =>
      apolloService.query(
        INGREDIENT_KEYWORDS_QUERY,
        { ingredientId },
        dispatch,
        COMMON_FETCH_INGREDIENT_KEYWORDS,
      ),
    [dispatch],
  )

  useCleanupRedux(cleanupCommonFetchIngredientKeywords)

  useEffect(() => {
    if (!lazy) {
      refetch(ingredientId)
    }
  }, [ingredientId, lazy, refetch])

  const queryState = { isLoading, error, data }
  return lazy ? [refetch, queryState] : queryState
}

export default useIngredientKeywordsQuery
